// Who counts as MINDSHINE STAFF.
//
// Some surfaces are internal engineering tools rather than product features —
// the embedded Flow studio is the first: it edits the endpoints and services
// every project runs on, so a customer seeing it is at best confusing and at
// worst dangerous.
//
// THE RULE IS THE EMAIL DOMAIN, AND ONLY THE EMAIL DOMAIN.
// Not org membership: external collaborators are routinely added to the mindshine
// org so they can reach a project, and that must not hand them the engine.
// Not roles either — an earlier version also let any `platform_admin` through on
// the theory that the role implies internal access. That was a hole: a
// non-mindshine platform admin is exactly the case this gate exists to exclude,
// and it let one straight past. Staff who need Flow already qualify by their
// @mindshine.com address, so there is nothing to add back.
const STAFF_DOMAIN = "mindshine.com";

export function isMindshineStaff(user) {
  if (!user) return false;
  // Compare only the part after the LAST '@', lowercased, and require an exact
  // match so "notmindshine.com" or "mindshine.com.evil.tld" cannot slip through
  // a substring test.
  const email = String(user.email || "").trim().toLowerCase();
  const at = email.lastIndexOf("@");
  return at > 0 && email.slice(at + 1) === STAFF_DOMAIN;
}

export { STAFF_DOMAIN };
